export default "__VITE_ASSET__c468cde8__"